import PlatformApi from './_platformApi';

class MergeTenantsApi extends PlatformApi {
  controllerName = 'MergeTenants';

  // [dkdien - 2026-09-22] Sửa: lấy tất cả đợt sáp nhập chưa hoàn thành để hiển thị thông báo
  getPendingMergerTenantDetails() {
    const request = {
      url: this.getAPIUrl() + '/pending',
    };
    return this.getAsync(request);
  }

  // [dkdien - 2026-09-22] Sửa: giữ API cũ cho các caller cần đọc một bản ghi theo context
  getMergerTenantDetail() {
    const request = {
      url: this.getAPIUrl()
    };
    return this.getAsync(request);
  }

  // [dkdien - 2026-09-23] Thêm mới: danh sách các đợt sáp nhập/hợp nhất chưa hoàn thành lấy dữ liệu
  getPendingMergerTenants() {
    const request = {
      url: `${this.getAPIUrl()}/pending`
    };
    return this.getAsync(request);
  }
}

export default new MergeTenantsApi();
